import { Query } from 'graphql/generated/graphqlTypes';

export function mockedGetTenantNameData(getTenantName: string): Pick<Query, 'getTenantName'> {
  return {
    getTenantName
  };
}

export const mockedGetTenantNameDataForQuery = mockedGetTenantNameData('mockedTenantName');
